import type { FileMapDataSubcategory } from '../types'
import { defaultStyleHidden } from './defaultStyle/defaultStyleHidden'
import { layers_maxspeed_above40 } from './layers/maxspeed_above40'
import { layers_maxspeed_all } from './layers/maxspeed_all'
import { layers_maxspeed_below30 } from './layers/maxspeed_below30'
import { wrapSourceLayers } from './layers/utils/wrapSourceLayers'

const subcatId = 'maxspeed'
const source = 'atlas_roads'
const sourceLayer = 'roads'
export type SubcatMaxspeedId = typeof subcatId
export type SubcatMaxspeedStyleIds = 'default' | 'below30' | 'above40'

export const subcat_maxspeed: FileMapDataSubcategory = {
  id: subcatId,
  name: 'Höchstgeschwindigkeit',
  ui: 'dropdown',
  sourceId: source,
  styles: [
    defaultStyleHidden,
    {
      id: 'default',
      name: 'Alle Höchstgeschwindigkeiten',
      layers: wrapSourceLayers({
        layers: layers_maxspeed_all,
        source,
        sourceLayer,
      }),
      legends: [
        {
          id: 'tl-80',
          name: 'TL ≥ 80 km/h',
          style: { type: 'line', color: '#b80505', width: 2 },
        },
        {
          id: 'tl-60',
          name: 'TL ≥ 60 km/h',
          style: { type: 'line', color: '#e92d07', width: 2 },
        },
        {
          id: 'tl-50',
          name: 'TL ≥ 50 km/h',
          style: { type: 'line', color: '#fc7c40', width: 2 },
        },
        {
          id: 'tl-40',
          name: 'TL ≥ 40 km/h',
          style: { type: 'line', color: '#eeb449', width: 2 },
        },
        {
          id: 'tl-30',
          name: 'TL ≥ 30 km/h',
          style: { type: 'line', color: '#2cb587', width: 2 },
        },
        {
          id: 'tl-20',
          name: 'TL ≥ 20 km/h',
          style: { type: 'line', color: '#08aec4', width: 2 },
        },
      ],
    },
    {
      id: 'below30',
      name: 'Nur Höchstgeschwindigkeit ≤30 km/h',
      layers: wrapSourceLayers({
        layers: layers_maxspeed_below30,
        source,
        sourceLayer,
      }),
      legends: [
        {
          id: 'tl-30',
          name: 'TL ≥ 30 km/h',
          style: { type: 'line', color: '#2cb587', width: 2 },
        },
        {
          id: 'tl-20',
          name: 'TL ≥ 20 km/h',
          style: { type: 'line', color: '#08aec4', width: 2 },
        },
      ],
    },
    {
      id: 'above40',
      name: 'Nur Höchstgeschwindigkeiten ≥40 km/h',
      layers: wrapSourceLayers({
        layers: layers_maxspeed_above40,
        source,
        sourceLayer,
      }),
      legends: [
        {
          id: 'tl-80',
          name: 'TL ≥ 80 km/h',
          style: { type: 'line', color: '#b80505', width: 2 },
        },
        {
          id: 'tl-60',
          name: 'TL ≥ 60 km/h',
          style: { type: 'line', color: '#e92d07', width: 2 },
        },
        {
          id: 'tl-50',
          name: 'TL ≥ 50 km/h',
          style: { type: 'line', color: '#fc7c40', width: 2 },
        },
        {
          id: 'tl-40',
          name: 'TL ≥ 40 km/h',
          style: { type: 'line', color: '#eeb449', width: 2 },
        },
      ],
    },
  ],
}
